"use strict";
/*

SHORTHANDS:
$menu      - compilator.menu

*/
// Defines compilator global namespace.
var compilator = compilator || {};

compilator.menu = {
  getRootUrl: function () {
    if (!window.location.origin) {
      //Om man vill testa att öppna Lagervärde på väg och kör det lokalt på sin dev maskin så byt ut till:  window.location.origin = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port; 
      if (window.location.port === "") {
        window.location.origin = window.location.protocol + "//" + window.location.hostname;
      }
      else {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port;
      }
    }
    const url = window.location.origin;
    return url;
  },

  openAccountsListSettingsWindow: function () {
    $url.SystemSettingsMVC.Accounting.AccountsListDialog.kendoWindow({ title: $translations.Common.AccountsListDialogTitle, width: 800, height: 600 });    
  },

  openCostCentreWindow: function (title) {
    $url.SystemSettingsMVC.Accounting.CostCentreDialog.kendoWindow({
      windowName: "_kwCostCentreDialog",
      title: $translations.Common.CostCentreWindowTitle,
      width: 700,
      height: 400
    });
  },

  openCarrierWindow: function () {
    const url = compilator.menu.getRootUrl() + "/SystemSettings/Windows/CarrierWindow.aspx";
    compilator.windowHandler.radWindow.openJSRadWindowDestroyOnClose(url, "_rwCarrierSettingsDialog", "", 450, 500, true);
  },

  openSupplierCategories: function () {
    const url = compilator.menu.getRootUrl() + "/Suppliers/Windows/SupplierCategories.aspx";
    compilator.windowHandler.radWindow.openJSRadWindowDestroyOnClose(url, "_rwSupplierCategoriesSettingsDialog", "", 450, 500, true);
  },

  openCustomerCategories: function () {
    const url = compilator.menu.getRootUrl() + "/Business/Windows/CustomerCategories.aspx";
    compilator.windowHandler.radWindow.openJSRadWindowDestroyOnClose(url, "_rwCustomerCategoriesSettingsDialog", "", 450, 500, true);
  },

  openBreakdownServices: function () {
    const url = compilator.menu.getRootUrl() + "/Business/Windows/BreakdownServices.aspx";
    compilator.windowHandler.radWindow.openJSRadWindowDestroyOnClose(url, "_rwBreakdownSericesSettingsDialog", "", 450, 500, true);
  },

  openTermsOfPayment: function () {
    const url = compilator.menu.getRootUrl() + "/Business/Windows/TermsOfPayment.aspx";
    compilator.windowHandler.radWindow.openJSRadWindowDestroyOnClose(url, "TermsOfPaymentWindow", "", 820, 530, true);
  },

  openInventoryReasons: function () {
    const url = compilator.menu.getRootUrl() + "/Stock/Windows/InventoryReasons.aspx";
    compilator.windowHandler.radWindow.openJSRadWindowDestroyOnClose(url, "InventoryReasonDialog", "", 450, 500, true);
  },

  openDailyCashBalanceTransactionDialog: function () {
    $url.OrderMVC.CashBalance.DailyCashBalanceTransactionsDialog.kendoWindow({ width: 600, height: 400 });
  },

  openDailyCashBalanceExportDialog: function () {
    $url.OrderMVC.CashBalance.DailyCashBalanceExportDialog.kendoWindow();
  },

  openPrintStockObsolescenceListDialog: function () {
    const url = compilator.menu.getRootUrl() + "/Stock/Windows/PrintStockObsolescenceListDialog.aspx";
    compilator.windowHandler.radWindow.openJSRadWindowDestroyOnClose(url, "StockObsolescenceListDialog", "", 620, 350, true);
  },

  openStockValueInTransfer: function () {
    const url = compilator.menu.getRootUrl() + "/Stock/Windows/PrintStockValueInTransferDialog.aspx";
    compilator.windowHandler.radWindow.openJSRadWindowDestroyOnClose(url, "StockValueInTransferDialog", "", 450, 350, true);
  },

  openPrintIndeliveryDialog: function () {
    const url = compilator.menu.getRootUrl() + "/Stock/Windows/PrintIndeliveryDialog.aspx";
    compilator.windowHandler.radWindow.openJSRadWindowDestroyOnClose(url, "PrintIndeliveryDialog", "", 620, 280, true);
  },

  openStorageListReport: function () {
    const url = compilator.menu.getRootUrl() + "/TyreHotel/Windows/StorageListReportDialog.aspx";
    $kendo.openNewKendoWindow(url, { width: 450, height: 600, iframe: true });
  },

  openStorageDirectMailReport: function () {
    const url = compilator.menu.getRootUrl() + "/TyreHotel/Windows/PreReservationLetterReportDialog.aspx";
    $kendo.openNewKendoWindow(url, { width: 700, height: 550, iframe: true });
  },

  openStorageNotChargedStorageCardsReport: function () {
    const url = compilator.menu.getRootUrl() + "/TyreHotel/Windows/ReportNotCharged.aspx";
    $kendo.openNewKendoWindow(url, { width: 410, height: 350 });
  },

  openFitterPerformanceDialog: function () {
    $url.OrderMVC.Reports.FitterPerformanceDialog.kendoWindow({ width: 400, height: 325 });
  },

  openECSalesListDialog: function () {
    $url.OrderMVC.Reports.ECSalesListDialog.kendoWindow({ width: 400, height: 325 });
  },
  openTopSellersDialog: function () {
    $url.OrderMVC.Reports.TopSellersDialog.kendoWindow({ width: 500, height: 500 });
  },
  openSalesVATSummaryDialog: function () {
    $url.OrderMVC.Reports.SalesVATSummaryDialog.kendoWindow({ width: 150, height: 275 });
  },

  openAgedDebtorsDialog: function () {
    $url.Business.CustomerReports.AgedDebtorsDialog.kendoWindow({ width: 800, height: 300 });
  },

  openAccumulatedJournalsDialog: function () {
    var url = '/Business/CustomerReports/AccumulatedJournalsDialog';
    var options = {
      width: 375,
      height: 325, 
      minWidth: 375,
      minHeight: 325
    };
    $kendo.openNewKendoWindow(url, options);
  },

  openAccountsPayableAccumulatedReportsDialog: function () {
    $url.AccountsPayable.Search.AccumulatedReportsDialog.kendoWindow();
  },

  openAccountsPayableReprintDialog: function (reprinttype) {
    $url.AccountsPayable.Print.ReprintDialog.kendoWindow(reprinttype);
  },

  showCustomerSearchDialog: function (origin) {
    if (!window.location.origin) {
      window.location.origin = window.location.protocol + "//" + window.location.hostname;
    }

    const url = window.location.origin + "/Business/Windows/CustomerSearch.aspx?origin=" + origin;
    $kendo.openNewKendoWindow(url, { width: 900, height: 500, onWindowClose: $menu.onSelectCustomerWinClose, iframe: true });
  },

  onSelectCustomerWinClose: function (args) {
    const win = $kendo._getCurrentKendoWindow();
    if (args && args.dialogResult !== "Cancel") {
      $("div#" + win.kendoWindow.options.windowName + " iframe")[0].contentWindow.getCustomerInformation(args);
    }
  },

  confirmStockTransactionResetAndDelete: function () {
    $url.SystemSettingsMVC.TradingStock.ConfirmStockTransactionResetAndCleanup.kendoWindow({
      width: 650,
      height: 500,
      title: $translations.Common.PeriodicStockCleaning,
      onWindowClose: function (arg) {
        if (arg) {
          if (arg.status === compilator.windowHandler.kendo.dialogResultOk) {
            notificationHandler.showNotification($translations.Common.StockCleanupHasBeenScheduled);
          } else if (arg.status === "JobCancelled") {
            notificationHandler.showNotification($translations.Common.StockCleanupHasBeenCancelled);
          }
        }
      }
    });
  },

  openExternalCentralWarehouseReservations: function () {
    const reservationUrl = $url.OrderMVC.Order.SearchExternalCentralWarehouseReservations.url();
    /*
    $.ajax({
      url: reservationUrl,
      type: 'GET',
    });
    */

    window.location.href = reservationUrl;
  }
};

var $menu = compilator.menu;